import React from 'react';
import './Clampings.css';
import clampingImg from '../../../imgs/durabil.webp';

const Clampings = () => {
  return (
    <div className="clampings-container">
      <div className="clampings-image">
        <img src={clampingImg} alt="Clamping System" />
      </div>
      <div className="clampings-text">
        <h2>CLAMPING SYSTEM</h2>
        <ul>
          <li>Short Circle Time</li>
          <li>High Precision</li>
          <li>High Rigidity</li>
          <li>High Durability</li>
        </ul>
        <p>
          High control precision of servo motor torque, and rigid connection of the ball screw and clampings system,
          correspondingly improve the mold opening/closing speed and position accuracy, and ensure an accurately platen moving thrust.
          Displacement deviation generated by platen movement inertia is under control, and the reliability and response accuracy
          of the low pressure mold protection system is greatly improved. The safety of using precision molds becomes better.
        </p>
      </div>
    </div>
  );
};

export default Clampings;
